import React from 'react';
import classNames from 'classnames';
import { IParticipantsPair, IResults } from 'twain-sport-fe-mono/interfaces';
import { StreamViews } from 'twain-sport-fe-mono/enums';
import { VideoPlayerStatistics } from '../VideoPlayerStatistics';
import { VideoPlayersIntro } from '../VideoPlayersIntro';
import { VideoResultSpinner } from '../VideoResultSpinner';
import classes from './VideoInfo.module.scss';

interface IProps {
    tournamentName: string;
    participants: IParticipantsPair;
    stage: string;
    results: IResults;
    view: number;
    isFullscreen?: boolean;
    animationDuration: number;
    videoResultSpinnerClassName?: string;
}

export const VideoInfo: React.FC<IProps> = (props) => (
    <>
        {props.view === StreamViews.USER_STATS && (
            <div
                className={classNames(classes.container, {
                    [classes.fullscreen]: props.isFullscreen,
                })}
            >
                <VideoPlayerStatistics participants={props.participants} />
            </div>
        )}
        {props.view === StreamViews.USER_INTRO && (
            <div
                className={classNames(classes.container, {
                    [classes.fullscreen]: props.isFullscreen,
                })}
            >
                <VideoPlayersIntro
                    stage={props.stage}
                    tournamentName={props.tournamentName}
                    participants={props.participants}
                />
            </div>
        )}
        {props.view === StreamViews.RESULTS && (
            <VideoResultSpinner
                animationDuration={props.animationDuration}
                participants={props.participants}
                results={props.results}
                isFullscreen={props.isFullscreen}
                className={props.videoResultSpinnerClassName}
            />
        )}
    </>
);
